// Browser entry point for @logdna-web/i18n/resources. Aliased in
// vite.config.js (`@logdna-web/i18n/resources` → this file).
//
// The CJS sibling `index.js` is the Jest entry point — it uses
// fs.readdirSync(__dirname) which works under Node but not in the
// browser. This file uses Vite's import.meta.glob to do the same thing
// at build time. Both produce the same shape:
//   { <locale>: { <namespace>: <translations object> } }

const allFiles = import.meta.glob('./*/*.json', { eager: true })

const resources = {}
for (const [path, mod] of Object.entries(allFiles)) {
  const match = path.match(/^\.\/([^/]+)\/(.+)\.json$/)
  if (!match) continue
  const [, locale, key] = match
  if (!resources[locale]) resources[locale] = {}
  resources[locale][key] = mod.default ?? mod
}

export default resources
